function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  stroke: "#63C",
  d: "M.5.5h707v467H.5z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#63C",
  d: "M354.5 254.5h595v698h-595z"
});

function SvgBookBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 950 953",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgOTUwIDk1MyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHg9IjAuNSIgeT0iMC41IiB3aWR0aD0iNzA3IiBoZWlnaHQ9IjQ2NyIgc3Ryb2tlPSIjNjYzM0NDIiAvPgogICAgPHJlY3QgeD0iMzU0LjUiIHk9IjI1NC41IiB3aWR0aD0iNTk1IiBoZWlnaHQ9IjY5OCIgc3Ryb2tlPSIjNjYzM0NDIiAvPgo8L3N2Zz4KICAgIA==";
export { SvgBookBackground as ReactComponent };